export const googleMapConfig: google.maps.MapOptions = {
   mapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID,
   streetViewControl: false,
   minZoom: 3,
   restriction: {
      latLngBounds: {
         north: 85,
         south: -85,
         west: -180,
         east: 180,
      },
      strictBounds: true,
   },
   fullscreenControl: false,
   mapTypeControl: false,
   cameraControl: false,
   clickableIcons: false,
};

export const MILES_IN_METERS = 1609.34;

export const MAP_CENTER_UPDATE_THRESHOLD_METERS = 2 * MILES_IN_METERS;

export const INITIAL_MAP_CENTER_LOCATION = {
   latitude: 34.213832269011164,
   longitude: -106.02623698718538,
   zoom: 9,
};

export const USER_LOCATION_DEFAULT_ZOOM = 9;

export const RADIUS_ADJUSTMENT_FACTOR = 0.75;

export const COORDINATE_PRECISION = 6;
